import { useState, useRef, TouchEvent, MouseEvent } from 'react';

interface UseChatListSwipeProps {
  onSwipe: (distance: number) => void;
  onSwipeEnd: () => void;
  onTap: () => void;
}

const useChatListSwipe = ({
  onSwipe,
  onSwipeEnd,
  onTap,
}: UseChatListSwipeProps) => {
  const [startPosition, setStartPosition] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const startTimeRef = useRef(0);
  const startXRef = useRef(0);

  const handleStart = (clientX: number) => {
    setStartPosition(clientX);
    setIsDragging(true);
    startTimeRef.current = Date.now();
    startXRef.current = clientX;
  };

  const handleMove = (clientX: number) => {
    const moveDistance = clientX - startPosition;
    if (Math.abs(moveDistance) > 5) {
      setIsDragging(true);
    }
    onSwipe(moveDistance);
    setStartPosition(clientX);
  };

  const handleEnd = (clientX: number) => {
    const endTime = Date.now();
    const duration = endTime - startTimeRef.current;
    const distance = Math.abs(clientX - startXRef.current);

    if (duration < 200 && distance < 5) {
      onTap();
    } else if (isDragging) {
      onSwipeEnd();
    }

    setIsDragging(false);
  };

  const onTouchStart = (event: TouchEvent<HTMLDivElement>) => {
    handleStart(event.touches[0].clientX);
  };

  const onTouchMove = (event: TouchEvent<HTMLDivElement>) => {
    handleMove(event.touches[0].clientX);
  };

  const onTouchEnd = (event: TouchEvent<HTMLDivElement>) => {
    const lastTouch = event.changedTouches[0];
    handleEnd(lastTouch.clientX);
  };

  const onMouseDown = (event: MouseEvent<HTMLDivElement>) => {
    handleStart(event.clientX);
  };

  const onMouseMove = (event: MouseEvent<HTMLDivElement>) => {
    if (event.buttons !== 1) return;
    handleMove(event.clientX);
  };

  const onMouseUp = (event: MouseEvent<HTMLDivElement>) => {
    handleEnd(event.clientX);
  };

  const onMouseLeave = (event: MouseEvent<HTMLDivElement>) => {
    if (isDragging) {
      handleEnd(event.clientX);
    }
  };
  const handlers = {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave,
  };

  return {
    handlers,
    isDragging,
  };
};

export default useChatListSwipe;
